import Hammer from 'hammerjs';

const DEFAULT_SPEED = 300;
const BUTTON_CLASS_CLOSE = 'b-mobile-burger_theme_close';
const MENU_CLASS_OPEN = 'b-mobile-menu_state_open';

class MobileMenu {
    constructor($mobileMenu) {
        this.$mobileMenu = $mobileMenu;
        this.$body = $('body');
        this.$header = $('.j-header');
        this.$overlay = $('.j-overlay');
        this.$button = this.$header.find('.j-burger-open');
        this.$navLinks = this.$mobileMenu.find('.b-nav__link');
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.$button.on('click', this._toggleStateElemens.bind(this));
        this.$navLinks.on('click', this._toggleStateElemens.bind(this));
        this.$overlay.on('click', this._toggleStateElemens.bind(this));
        new Hammer(this.$mobileMenu[0]).on(`swiperight`, this._toggleStateElemens.bind(this));
    }

    _toggleStateElemens() {
        this.$mobileMenu.toggleClass(MENU_CLASS_OPEN);
        this.$button.toggleClass(BUTTON_CLASS_CLOSE);
        this.$body.toggleClass('b-body-fixed');
        this.$overlay.fadeToggle(DEFAULT_SPEED);
    }
}

export default MobileMenu;
